"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adEvents_1 = require("../../../types/sports/rugbyUnion/adEvents");
exports.rugbyUnionAdEvents = [
    adEvents_1.RugbyUnionAdAllocationEvent.try,
    adEvents_1.RugbyUnionAdAllocationEvent.dropGoal,
    adEvents_1.RugbyUnionAdAllocationEvent.conversion,
    adEvents_1.RugbyUnionAdAllocationEvent.penaltyGoal,
    adEvents_1.RugbyUnionAdAllocationEvent.redCard,
    adEvents_1.RugbyUnionAdAllocationEvent.yellowCard,
    adEvents_1.RugbyUnionAdAllocationEvent.penaltyConceded
];
//# sourceMappingURL=adEvents.js.map